import { render, staticRenderFns } from "./Workbenches.vue?vue&type=template&id=0688c371&scoped=true&"
import script from "./Workbenches.vue?vue&type=script&lang=js&"
export * from "./Workbenches.vue?vue&type=script&lang=js&"
import style0 from "./Workbenches.vue?vue&type=style&index=0&id=0688c371&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688c371",
  null
  
)

export default component.exports